export default {
    fields: [
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: false,
        },
        {
            key: "value",
            label: "value",
            type: "input",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label: "options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
        },
    ],
    items: []
}